// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignUpPage from './pages/SignUpPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import PSTUploadPage from './pages/PSTUploadPage';
import SignInPage from './pages/SignInPage';
import ProtectedRoute from './components/ProtectedRoute'; // import it
import AzureBlobUpload from './components/Test';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/verify" element={<VerifyEmailPage />} />
        <Route
          path="/upload"
          element={
            <ProtectedRoute>
              <PSTUploadPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
    // <div>
    //   <AzureBlobUpload/>
    // </div>
  );
}

export default App;